import { render, staticRenderFns } from "./PreReceivePurchasingDetail.vue?vue&type=template&id=bfa81ccc&"
import script from "./PreReceivePurchasingDetail.vue?vue&type=script&lang=js&"
export * from "./PreReceivePurchasingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports